import { ReceiptSummaryState, ReceiptActionTypes, ReceiptActions } from '../../types/receipt-summary.store.type';

const initialState: ReceiptSummaryState = { isLoading: false, error: null };

export function receiptSummaryReducer(state = initialState, action: ReceiptActionTypes): ReceiptSummaryState {
    switch (action.type) {
        case ReceiptActions.RECEIPT_FETCH_BEGIN: {
            return { isLoading: true, error: null };
        }
        case ReceiptActions.RECEIPT_FETCH_SUCCESS: {
            return { isLoading: false, error: null, receiptSummary: action.payload };
        }

        case ReceiptActions.RECEIPT_FETCH_ERROR: {
            return { isLoading: false, error: action.payload };
        }
        default:
            return state;
    }
}
